let alertApiUrl : string = "";


export class AlertService {
  public static setApiUrl(apiUrl : string) {
    alertApiUrl = apiUrl;
  }

  public static getApiUrl() {
      return  alertApiUrl;
  }
}